import { formatDate } from "./common";

/**
 * Read first some lines from parquet file
 * @param {File} file File object
 * @param {number} linesCount How many lines to read from file
 * @returns {headers & data}
 */
const readFirstLines = async (file, linesCount) => {
  const result = {};
  try {
    await window.parquet.default();
    const Type = window.Arrow.Type;

    //Reading parquet file
    const parquetFile = await window.parquet.ParquetFile.fromFile(file);

    //Reading only required lines
    const stream = (
      await parquetFile.read({
        offset: 0,
        limit: linesCount,
      })
    ).intoIPCStream();

    //Getting data using tableFromIPC
    const data = window.Arrow.tableFromIPC(stream);

    //Creating data array
    const rData = [];
    for (let i = 0; i < data.numRows; i++) rData.push([]);

    //Headers/column names
    result.headers = data?.schema?.fields.map(({ name }) => name);

    //Generating data array
    for (let row = 0; row < data?.schema?.fields?.length; row++) {
      const rowValues = data.getChildAt(row);

      if (data?.schema?.fields[row].typeId === Type.Binary) {
        [...rowValues.toArray()].forEach((val, i) => {
          rData[i].push(new TextDecoder().decode(val));
        });
      } else {
        [...rowValues.toJSON()].forEach((val, i) => {
          if (data?.schema?.fields[row].typeId === Type.Int) rData[i].push(val ? parseInt(val).toString() : "");
          else if ([Type.Date, Type.Time, Type.Timestamp].includes(data?.schema?.fields[row].typeId))
            rData[i].push(formatDate(new Date(val)));
          else rData[i].push(val ? val.toString() : "");
        });
      }
    }

    result.data = rData;

    return result;
  } catch (error) {
    console.error("Error reading Parquet file:", error);
    console.log("Error reading Parquet file: " + error.message);

    if (result.headers)
      return {
        headers: result.headers,
        data: [],
      };

    throw error;
  }
};

export { readFirstLines };
